import React from "react";
import {css, useTheme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {calculateRemSize, flexAbsoluteCenter} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons";

interface IProps {
    onClose: () => void;
    className?: string;
}

export const CloseButton = (props: IProps) => {
    const theme = useTheme();

    return (
        <div css={closeButton} className={props.className} onClick={props.onClose}>
            <CloseIcon size="1.6" fill={theme.colors.secondary} />
        </div>
    );
};

const closeButton = css`
    border-radius: 50%;
    background-color: #fff;
    width: ${calculateRemSize(4)};
    height: ${calculateRemSize(4)};
    ${elevation(3)};
    ${flexAbsoluteCenter};
    cursor: pointer;
`;
import React from "react";
import {css, useTheme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {calculateRemSize, flexAbsoluteCenter} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons";

interface IProps {
    onClose: () => void;
    className?: string;
}

export const CloseButton = (props: IProps) => {
    const theme = useTheme();

    return (
        <div css={closeButton} className={props.className} onClick={props.onClose}>
            <CloseIcon size="1.6" fill={theme.colors.secondary} />
        </div>
    );
};

const closeButton = css`
    border-radius: 50%;
    background-color: #fff;
    width: ${calculateRemSize(4)};
    height: ${calculateRemSize(4)};
    ${elevation(3)};
    ${flexAbsoluteCenter};
    cursor: pointer;
`;
